// extracted by mini-css-extract-plugin
export default {"headerActive":"styles-module__headerActive__src-labstep-web-grid-Index-_vjEAB"};